// ShoppingListPage styles
export const pageContainer = (theme) => ({
  display: "flex",
  flexDirection: "column",
  px: { xs: 1, sm: 2 },
  maxWidth: "100%",
});

export const pageHeaderContainer = (theme) => ({
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  alignItems: { xs: "stretch", sm: "center" },
  justifyContent: "space-between",
  gap: { xs: 1, sm: 2 },
  width: "100%",
  mb: 2,
});

export const itemList = {
  width: "100%",
  p: 0,
  overflowX: "hidden",
};

export const itemWrapper = {
  width: "100%",
};

// ShoppingListItem styles
export const listItem = (theme, isEditing) => ({
  px: { xs: 1, sm: 2 },
  flexWrap: isEditing ? "wrap" : "nowrap",
  cursor: isEditing ? "default" : "pointer",
  flexDirection: "row",
  ...(isEditing && {
    flexDirection: { xs: "column", md: "row" },
  }),
});

export const checkbox = (theme) => ({
  color: theme.palette.primary.main,
  p: { xs: 1, sm: 1.5 },
  display: "flex",
});

export const itemContent = () => ({
  flexGrow: 1,
  width: "100%",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
});

export const itemReadOnlyText = {
  py: 1,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export const itemFormContainer = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: 2,
  pt: 1.5,
  pb: 1,
};

export const editFieldsContainer = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  width: "100%",
  gap: 2,
  alignItems: { xs: "stretch", md: "flex-start" },
};

export const formField = {
  flex: { md: 1 },
};

export const notesField = {
  width: "100%",
};

export const actionsContainer = {
  display: "flex",
  alignItems: "center",
  justifyContent: { xs: "flex-end", md: "center" },
  mt: { xs: 2, md: 0 },
  ml: { md: 2 },
  alignSelf: { md: "center" },
  flexShrink: 0,
  width: { xs: "100%", md: "auto" },
  flexDirection: { md: "row" },
  gap: { md: 1 },
};

export const actionButton = (theme, colorKey) => ({
  color: theme.palette[colorKey].main,
  p: { xs: 1, sm: 1.5 },
});
